import React, { useEffect, useState } from 'react';
import style from './Spinner.module.scss'; // Import css modules stylesheet as styles


export interface Props {
    color?: string;
    text?: string;
    timeout?: any;
}

const Spinner = (props: Props) => {
    const [ready, setReady] = useState(false);

    useEffect(() => {
        console.log('mounted')
        let timeout = setTimeout(() => {
            setReady(true);
        }, props.timeout || 3000)

        // this will clear Timeout when component unmount like in willComponentUnmount
        return () => {
            clearTimeout(timeout)
        }
    }, []);


    return ready ? <div className={style.loading}>
        <div className={style.wrapper}>
            <div className={style.loader}>
                <svg
                    version="1.1"
                    id="loader-1"
                    x="0px"
                    y="0px"
                    viewBox="0 0 50 50"
                >
                    <path d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
                        <animateTransform
                            attributeType="xml"
                            attributeName="transform"
                            type="rotate"
                            from="0 25 25"
                            to="360 25 25"
                            dur="0.8s"
                            repeatCount="indefinite"
                        />
                    </path>
                </svg>
            </div>
            <div className={style.logo}>
                {/* <svg viewBox="0 0 429.333 184">
        <path
          d="M158.71 179.04c-27.459-6.67-42.137-29.782-37.921-59.706 4.316-30.633 17.302-55.954 39.634-77.282 12.079-11.535 21.592-18.031 37.008-25.27 26.782-12.575 61.938-15.405 87.667-7.056 3.483 1.13 6.325 2.757 6.314 3.614-.014 1.233-5.121 18.818-11.55 39.77-.61 1.993-4.188 3.724-7.795 3.772-.798.01-1.4-3.993-1.45-9.649-.049-5.316-.859-12.066-1.801-15-4.385-13.648-17.12-18.881-35.68-14.66-28.197 6.413-57.223 37.6-70.106 75.326-13.475 39.458-7.737 70.85 13.899 76.04 15.982 3.833 30.827-3.206 53.599-25.417 15.675-15.289 16.158-15.632 19.185-13.649l3.105 2.035-3.518 6.002c-4.601 7.852-7.734 12.43-17.864 26.108l-8.394 11.333-14.805 2.787c-16.667 3.137-38.679 3.538-49.527.902zm214.49-.866c-17.723-3.504-22.109-11.692-26.506-49.483-2.469-21.219-3.728-23.791-11.647-23.791h-5.656l-10.313 25.769c-5.672 14.173-10.313 27.339-10.313 29.258 0 3.85 4.257 7.628 8.63 7.66 5.313.04 6.507 1.87 4.17 6.39l-2.118 4.096-34.674.116c-21.833.074-34.674-.367-34.674-1.19 0-.718.685-2.81 1.522-4.647 1.2-2.633 3.106-3.667 9-4.883 9.328-1.924 15.237-7.702 20.444-19.994 21.437-50.602 47.887-115.93 48.508-119.82.97-6.066-1.19-8.157-9.376-9.08l-5.9-.665 2.148-4.504 2.148-4.505h36.238c19.93 0 39.47.606 43.42 1.346 20.319 3.806 29.92 16.524 26.78 35.475-3.519 21.245-20.817 41.239-42.686 49.34-3.435 1.272-6.437 2.448-6.671 2.613-1.108.782 4.205 32.181 7.653 45.227 5.186 19.623 5.802 21.005 11.4 25.62 4.477 3.69 4.713 4.24 3.22 7.514-1.515 3.327-2.122 3.524-10.395 3.387-4.832-.08-11.29-.642-14.351-1.247zm-19.715-85.999c14.096-3.652 24.586-12.814 31.989-27.941 11.654-23.813 6.966-44.667-10.043-44.667-7.02 0-11.107 3.141-15.021 11.544-6.231 13.377-24.979 59.386-24.979 61.3 0 2.477 7.983 2.373 18.053-.236zM6.755 176.887c-.23-.374.363-2.539 1.318-4.81 1.513-3.6 2.546-4.222 8.033-4.84 7.967-.899 12.39-4.156 16.889-12.44 3.86-7.108 46.516-108.62 50.607-120.44 1.373-3.965 2.496-8.346 2.496-9.735 0-2.82-7.054-6.39-12.624-6.39-3.714 0-4.006-.834-2.075-5.913l1.3-3.42h36.033c19.818 0 36.033.33 36.033.732 0 .403-.874 2.422-1.941 4.487-1.585 3.065-3.05 3.879-7.981 4.434-11.775 1.328-15.071 5.483-26.716 33.68-4.24 10.266-9.953 24.066-12.695 30.666-28.864 69.472-31.013 75.108-30.07 78.871.886 3.526 5.386 5.796 11.489 5.796 4.247 0 4.579.742 2.629 5.87l-1.284 3.378-35.511.376c-19.531.207-35.7.07-35.93-.303z"
        />
      </svg> */}
            </div>
        </div>
        <p>{props.text}</p>
    </div> : null
};

export default Spinner;
